// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.9971 16.9287L23.0088 17.0879L22.9697 17.2422L21.9697 21.2422L21.7812 22H2.21875L2.03027 21.2422L1.03027 17.2422L0.991211 17.0879L1.00293 16.9287L2.06934 2H21.9307L22.9971 16.9287ZM3.78027 20H20.2197L20.7197 18H3.28027L3.78027 20ZM5.5 13.5H18.5V11.5H5.5V13.5ZM5.5 9H18.5V7H5.5V9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-collection-1-filled')
export default class Collection1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'collection-1-filled',
    }
  }
}
